import { render, staticRenderFns } from "./DaftarKontak.vue?vue&type=template&id=3c82139d&scoped=true&"
import script from "./DaftarKontak.vue?vue&type=script&lang=js&"
export * from "./DaftarKontak.vue?vue&type=script&lang=js&"
import style0 from "./DaftarKontak.vue?vue&type=style&index=0&id=3c82139d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c82139d",
  null
  
)

export default component.exports